import React from 'react';
import { useSelector } from "react-redux";
import { Input } from '../../components/ui/input';
import DateInputwithcal from '../../components/ui/DateInputwithcal';
import CelebrationButton from '@/components/ui/CelebrationButton/CelebrationButton';

const VesselModal = ({  open, onClose, formData, errors, handleInputChange,handleDateError,handleDateChange, onSave,editData  }) => {

  if (!open) return null;
    //  const [formData, setFormData] = useState();
     const { countryList,carrierList } = useSelector((state) => state.common); 
        const { isAnimate } = useSelector((state) => state.toast);

          const options = (countryList || [])?.map((loc) => {
    const match = (loc.incoterm || "").match(/\(([^)]+)\)/);
    const code = match ? match[1] : null;
    return {
      value: code,
      label: loc.incoterm,
    };
  });

    const inputClass = "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-slate-800 w-[520px] rounded-md shadow-lg">

        {/* Header */}
        <div className="px-4 py-2 bg-sky-500 text-white font-medium rounded-t-md">
          Vessel Information
        </div>

       <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800">
        {/* Body */}
        <div className="p-4 space-y-4">

          {/* Carrier */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              Carrier:
            </label>
            <div className="col-span-9">
            
              <select className={inputClass} name="carrierScac"  value={formData?.carrierScac || ""} 
                onChange={(e) => {
                    handleInputChange({ target: { name: 'carrierScac', value: e.target.value } });
                    handleInputChange({ target: { name: 'carrier', value: e.target.options[e.target.selectedIndex].text } });
                }}
              >
               <option value="">select</option>
                {
                    carrierList?.map((group, key) => (
                        <option key={key} selected={formData?.carrierScac === group.carrierScac} value={group.carrierScac}>{group.carrierName}</option>
                    ))
                }
            </select>
             
            </div>
          </div>

          {/* Vessel Name */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              Vessel Name: <span className="text-red-500">*</span>
            </label>
            <div className="col-span-9">
              <Input className={inputClass}
                type="text"
                name="vessel"
                value={formData?.vessel || ""}
                onChange={handleInputChange}
              />   
              {errors?.vessel && <span className="text-red-500 text-[11px]">
                    {errors?.vessel}
                  </span> }        
            </div>
          </div>

          {/* IMO */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              IMO:
            </label>
            <div className="col-span-9">
              <Input className={inputClass}
                type="text"
                name="imo"
                value={formData?.imo || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* Flag */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              Flag:
            </label>
            <div className="col-span-9">
              <select
                className={inputClass}
                name="flag"
                value={formData?.flag || ""}
                onChange={handleInputChange}
              >
                <option value="">Select Country</option>
                 {
                    (options || [])?.map((country, key) => (
                        <option key={key} value={country?.value}>{country?.label}</option>
                    ))
                }
              </select>
            </div>
          </div>

          {/* Built Year */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              Built Year:
            </label>
            <div className="col-span-9">
              

               <DateInputwithcal onError={handleDateError} label="Insurance Valide Date" name="builtYear" value={formData?.builtYear} onChange={handleDateChange} required />
            </div>
          </div>

          {/* Call Sign */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              Call Sign:
            </label>
            <div className="col-span-9">
              <Input className={inputClass}
                type="text"
                name="callSign"
                value={formData?.callSign || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* MMSI */}
          <div className="grid grid-cols-12 items-center gap-2">
            <label className="col-span-3 text-xs font-medium text-slate-600 dark:text-slate-400">
              MMSI:
            </label>
            <div className="col-span-9">
              <Input className={inputClass}
                type="text"
                name="mmsi"
                value={formData?.mmsi || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          
        </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center gap-2 px-4 py-3 border-t dark:border-slate-700">
           <CelebrationButton
              onClick={() => onSave()}
              label={"Save"}
              className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
              icon={<></>}
              isSuccess={isAnimate}
             
           />
        
          <button
            onClick={onClose}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default VesselModal;
